
import React from 'react';
import { CreatePlaylistDialog } from '@/components/collections/CreatePlaylistDialog';
import { motion } from 'framer-motion';
import { FolderHeart } from 'lucide-react';

interface CollectionsHeaderProps {
  isAuthenticated: boolean;
}

export const CollectionsHeader = ({ isAuthenticated }: CollectionsHeaderProps) => {
  return (
    <motion.div 
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8 p-4 sm:p-6 bg-white/50 backdrop-blur-sm rounded-lg border"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-start sm:items-center space-x-3">
        <div className="p-2.5 sm:p-3 rounded-full bg-primary/10 flex-shrink-0">
          <FolderHeart className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">Collections</h1>
          <p className="text-xs sm:text-sm md:text-base text-gray-600">Organize and save your favorite travel destinations</p>
        </div>
      </div>
      <div className="ml-auto sm:ml-0">
        <CreatePlaylistDialog isAuthenticated={isAuthenticated} />
      </div>
    </motion.div>
  );
};
